import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import refexLogo from "../../src/assets/loginHeader.webp";
import ValidatedInput from "../components/ValidatedInput";
import bg from "../assets/loginBackground.webp";
import "../styles/Login.css";
import { loginService } from "../services/loginService";
import { fetchModulesByRole } from "../services/moduleService";
import { isTokenValid } from "../services/authService";

const LoginForm = () => {
  const navigate = useNavigate();

  const [formvalue, setFormValue] = useState({
    UserId: "",
    Password: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (isTokenValid()) {
      console.log("Token valid → redirecting to /live");
      navigate("/live", { replace: true });
      return; 
    }

    const savedUser = localStorage.getItem("savedUserId");
    const savedPass = localStorage.getItem("savedPassword");

    if (savedUser && savedPass) {
      setFormValue({
        UserId: savedUser,
        Password: savedPass,
      });
      setRememberMe(true);
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormValue({ ...formvalue, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const errors = {};
    if (!formvalue.UserId) errors.UserId = "User Name is required";
    if (!formvalue.Password) errors.Password = "Password is required";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validate();
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    try {
      const apiResponse = await loginService({
        username: formvalue.UserId,
        password: formvalue.Password,
      });

      const { success, message, token, expiresAt, roleId } = apiResponse;

      if (success) {
        if (rememberMe) {
          localStorage.setItem("savedUserId", formvalue.UserId);
          localStorage.setItem("savedPassword", formvalue.Password);
        } else {
          localStorage.removeItem("savedUserId");
          localStorage.removeItem("savedPassword");
        }

        localStorage.setItem("authToken", token);
        localStorage.setItem("tokenExpiry", expiresAt);
        localStorage.setItem("isLogin", "true");
        localStorage.setItem("username", formvalue.UserId);
        localStorage.setItem("roleId", roleId);

        const modules = await fetchModulesByRole(roleId);
        localStorage.setItem("modules", JSON.stringify(modules));

        navigate("/live");
      } else {
        alert(message || "Login failed");
      }
    } catch (error) {
      console.error(error);
      alert(error?.message || "Invalid Credentials");
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "100vh",
        width: "100vw",
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={refexLogo}
        alt="Logo"
        className="top-left-corner"
        style={{ width: "160px" }}
      />

      <div className="login-box">
        <form onSubmit={handleSubmit}>
          <div className="mb-2">
            <ValidatedInput
              type="text"
              name="UserId"
              className="form-control"
              placeholder="User ID"
              value={formvalue.UserId}
              onChange={handleChange}
              style={{
                height: "2.8rem",
                borderRadius: "10px",
                paddingLeft: "15px",
              }}
            />
            {formErrors.UserId && (
              <div className="text-danger">{formErrors.UserId}</div>
            )}
          </div>

          <div className="mb-2 password-wrapper">
            <ValidatedInput
              type={showPassword ? "text" : "password"}
              name="Password"
              className="form-control"
              placeholder="Password"
              value={formvalue.Password}
              onChange={handleChange}
              style={{
                height: "3rem",
                lineHeight: "3rem",
                borderRadius: "10px",
                paddingLeft: "15px",
                paddingRight: "44px",
              }}
            />

            <span
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    d="M17.94 17.94A10.94 10.94 0 0 1 12 20
                 C7 20 2.73 16.11 1 12
                 a21.7 21.7 0 0 1 5.17-7.29"
                  />
                  <path d="M1 1l22 22" />
                </svg>
              ) : (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    d="M1 12s4-8 11-8 11 8 11 8
                 -4 8-11 8-11-8-11-8z"
                  />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              )}
            </span>

            {formErrors.Password && (
              <div className="text-danger">{formErrors.Password}</div>
            )}
          </div>

          {/* UI kept same but not functional */}
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="checkbox-f4553b form-check-input"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label
              className="form-check-label"
              style={{ color: "white", marginBottom: "5px" }}
            >
              Remember Me
            </label>
          </div>

          <button
            type="submit"
            className="login-button"
            style={{
              backgroundColor: "#F4553B",
              borderColor: "#F4553B",
              borderBottom: "#F4553B",
              borderRight: "#F4553B",
              borderLeft: "#F4553B",
              height: "2.8rem",
              borderRadius: "10px",
              color: "white",
            }}
          >
            LOGIN
          </button>

          {/* UI kept same but not functional */}
          <div className="text-center mt-1" style={{ textAlign: "center" }}>
            <a
              style={{
                cursor: "pointer",
                color: "white",
                fontSize: "12px",
                textDecoration: "underline",
              }}
            >
              Forget Password?
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
